import {
  type Entry,
  type ICreditCardFields,
  type IPaymentMethod,
  type IPayPalFields,
  PAYMENT_TYPES
} from '@belong/types';
import { FImage } from '../image.factory';
import { FGenericInput } from '../inputs';
import { FMoleculeAlert } from '../molecules/moleculeAlert.factory';
import { parseFlexibleContent } from '../parseFlexibleContent';

interface IPaymentMethodEntry {
  paymentType: 'CREDIT_CARD' | 'PAYPAL';
  heading: string;
  copy: string;
  footerNote?: string;
  image: Entry<any>;
  inputs: Entry<any>[];
  successAlert?: Entry<any>;
  errorAlert?: Entry<any>;
}

export const FPaymentMethod = (data: Entry<IPaymentMethodEntry>): IPaymentMethod => {
  const { heading, copy, footerNote, image, paymentType, inputs = [], successAlert, errorAlert } = data.fields;
  const parsedInputs = parseFlexibleContent(inputs, new Map([['inputGeneric', { factory: FGenericInput }]]));
  const basePaymentMethod = {
    heading,
    copy,
    footerNote,
    image: image && FImage(image),
    successAlert: successAlert && FMoleculeAlert(successAlert),
    errorAlert: errorAlert && FMoleculeAlert(errorAlert)
  };

  if (paymentType === 'CREDIT_CARD') {
    return {
      ...basePaymentMethod,
      paymentType: PAYMENT_TYPES.CREDIT_CARD,
      inputs: parsedInputs as ICreditCardFields
    };
  }

  return {
    ...basePaymentMethod,
    paymentType: PAYMENT_TYPES.PAYPAL,
    inputs: parsedInputs as IPayPalFields
  };
};
